
<template>
 <div class="HomePage">
  <!-- Marquee section - uncomment to restore
  <div class="break"></div>
  <MarqueeText></MarqueeText>
  <div class="break"></div>
  -->

  <!-- Desktop quote bar - hidden on mobile -->


 <section ref="hero" class="hero-section">
   <div class="hero-card">
     <p class="eyebrow">Niles, Michigan Roofing Services</p>
     <h1>Residential & Commercial Roofing Contractor in Niles, MI</h1>
     <p class="hero-intro">Proudly serving communities across the Great Lakes State</p>

     <div class="hero-actions">
       <a href="tel:+12692625055" class="hero-phone-link"><svg class="phone-icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z"/></svg><span>Call (269) 262-5055</span></a>
     </div>

     <!-- Visible link only (not in the page tags), so Gaylord visitors who land here
          from a company-name search are one tap from their own page. -->
     <router-link to="/gaylord-roof-repair" class="other-location-link">
       In Gaylord or Northern Michigan? <span>Visit our Gaylord page →</span>
     </router-link>

     <ul class="trust-points">
       <li>Locally Owned and Operated</li>
       <li>Licensed and insured for your protection</li>
       <li>Financing Options Available</li>
       <li>High-quality materials and workmanship</li>
       <li>Free estimates and competitive pricing</li>
       <li>Roofing repair services available</li>
       <li>Customer satisfaction guaranteed</li>
     </ul>

     <div class="hero-quote-actions">
       <ContactForm variant="hero"></ContactForm>
     </div>
   </div>
 </section>

 <TrustStrip />

 <div v-if="showContactForm" class="floatingContact">
   <ContactForm :modal="this.modal"></ContactForm>
 </div>

   <!-- Main content wrapper with gradient background -->
   <div class="main-content-wrapper">
   <div class="break"></div>
   <div class="Services">
    <span class="ServicesTitle">Rated 5.0 Stars on Google</span>
    <CustomerTestimonials/>
   </div>
   <div class="break"></div>
    <HowItWorks/>
    <StormHelpBand/>
   <div class="break"></div>
    <IdentityPage/>
   <div class="break"></div>
    <LicensedInsured/>
    <AwardsPage/>
  <div class="break"></div>
    <WarrantyFinancing/>
  <div class="break"></div>
  <div class="Services">    <span class="ServicesTitle">Niles & Southwest Michigan Service Area</span>
    <p class="section-intro">
      We proudly serve homeowners throughout Southwest Michigan, including:
    </p>
    <ul class="service-area-list">
      <li v-for="area in serviceAreas" :key="area">{{ area }}</li>
    </ul>
    <div class="map-embed">
      <iframe
        src="https://www.google.com/maps?q=Niles,+MI+49120&z=10&output=embed"
        title="Map of Homes Roofing Co service area covering Niles and Southwest Michigan"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        allowfullscreen>
      </iframe>
    </div>
   </div>
   <div class="break"></div>
   <div class="Services">   <span class="ServicesTitle">Services</span>
   <div class="serviceSelection">
     <PhotoCard v-for="(service, index) in services" :key="index"
     :Services="service" @click="goToPage(service.path)">
    </PhotoCard>
   </div>
   <div class="break"></div>
   <FaqList heading="Roofing Questions from Niles Homeowners" :faqs="faqs" schema-id="home-faq"/>
   <div class="break"></div>
   <DonateCTA/>

 </div>
 <div class="break"></div>
 <div id="footer">
   <PageFooter :transparentBackground="true"/>
 </div>
 </div>
 <!-- End main content wrapper -->

 </div>
 </template>
 
 <script>
 import ContactForm from '@/components/ContactForm.vue';
 import PhotoCard from '@/components/NewServiceSelector.vue';
 import PageFooter from '@/components/PageFooter.vue';
 import LicensedInsured from '@/components/LicensedInsured.vue';
 import IdentityPage from '@/components/IdentityPage.vue';
 import AwardsPage from '@/components/AwardsPage.vue';
 import CustomerTestimonials from '@/components/CustomerTestimonials.vue';
 import DonateCTA from '@/components/DonateCTA.vue';
 import TrustStrip from '@/components/TrustStrip.vue';
 import HowItWorks from '@/components/HowItWorks.vue';
 import StormHelpBand from '@/components/StormHelpBand.vue';
 import WarrantyFinancing from '@/components/WarrantyFinancing.vue';
 import FaqList from '@/components/FaqList.vue';
 import { upsertJsonLd, removeJsonLd } from '@/utils/seo';
 import business from '@/seo/business.json';
 
 export default {
   name: 'HomePage',
   data(){
     return{
       modal: false,
       services: [

       {
         imageSrc: require('@/assets/RoofingRepairPhoto.card.webp'),
         title: 'Full Roof Replacements',
          path: '/roof-replacement',
       },

       {
         imageSrc: require('@/assets/FasciaSoffit/Roof1.card.webp'),
         title: 'Fascia & Soffit',
         path: '/fascia-soffit',
       },

       {
         imageSrc: require('@/assets/Repairs/Repair1.card.webp'),
         title: 'Roofing Repairs',
         path: '/roof-repair',
       },

     ],
     serviceAreas: [
       'Niles',
       'Buchanan',
       'Berrien Springs',
       'Dowagiac',
       'Edwardsburg',
       'St. Joseph',
       'Cassopolis'
     ],
     faqs: [
       {
         question: 'How much does a new roof cost in Niles, MI?',
         answer: 'It depends on the size and pitch of the roof, the materials you choose, and whether the old layers or damaged decking need to come off. We give free, no-obligation estimates so you get a real number for your home instead of a guess.'
       },
       {
         question: 'Do you offer a warranty on new roofs?',
         answer: 'Yes. Ask about our 50-year warranty during your free estimate and we will explain exactly what it covers for your roof before any work starts.'
       },
       {
         question: 'Do you offer financing?',
         answer: 'Yes. Financing is available on projects over $3,000 through our partner Enhancify. Checking your options uses a soft credit check that will not affect your credit score.'
       },
       {
         question: 'Are you licensed and insured?',
         answer: 'Yes. Homes Roofing Co LLC is licensed by the State of Michigan (license #252400025) and carries $1,000,000 in general liability insurance. Certificates of insurance are available on request, and you can verify our license on the Michigan LARA website.'
       },
       {
         question: 'Can you help with storm damage and insurance claims?',
         answer: 'Yes. We inspect your roof for free after wind, hail or tree damage, photograph the damage so you can send it to your insurance company, and make lasting repairs. Call (269) 262-5055.'
       },
       {
         question: 'What areas do you serve?',
         answer: 'From Niles we serve Southwest Michigan, including Buchanan, Berrien Springs, Dowagiac, Edwardsburg, St. Joseph and Cassopolis, across Berrien and Cass counties.'
       },
       {
         question: 'Do you work on commercial buildings?',
         answer: 'Yes. We handle both residential and commercial roofing, from repairs to full replacements. Call for a free estimate on your property.'
       }
     ],
     showContactForm: true,
     isMobile: window.innerWidth <= 1024,
     }
   },
 
   components: {
     ContactForm,
     PhotoCard,
     PageFooter,
     LicensedInsured,
    CustomerTestimonials,
    IdentityPage,
    AwardsPage,
    DonateCTA,
    TrustStrip,
    HowItWorks,
    StormHelpBand,
    WarrantyFinancing,
    FaqList
   },
   mounted() {
     upsertJsonLd('home-local-business', business.niles);

     upsertJsonLd('home-website', business.website);
   },
   beforeUnmount() {
     removeJsonLd('home-local-business');
     removeJsonLd('home-website');
   },
   methods: {
   goToPage(path) {
      this.$router.push(path);
    },
 },

 }
 </script>
 
 <style>
  .HomePage {
    margin-top: 93px;
    background: linear-gradient(135deg, #002655 0%, #1a3a5c 50%, #4a7ba7 100%);
    color: #ffffff;
  }

  /* Main content wrapper with gradient background */
  .main-content-wrapper {
    background: linear-gradient(135deg, #002655 0%, #1a3a5c 50%, #4a7ba7 100%);
    width: 100%;
  }
  
  @media (max-width: 1024px) {
    .HomePage {
    margin-top: 90px;
  } 

 }

.hero-section {
  max-width: 1080px;
  margin: 0 auto;
  padding: 30px;
  text-align: center;
  padding-top: 70px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof Mobile.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  max-width: none;
  margin: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 50px;
}

@media (min-width: 1025px) {
  .hero-section {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof.webp');
    min-height: 82vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 70px;
  }
}

.hero-card {
  max-width: 920px;
  margin: 0 auto;
  padding: 30px;
  background: rgba(255, 255, 255, 0.07);
  border-left: 5px solid #f1c40f;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}

.hero-card .eyebrow {
  font-size: clamp(0.7rem, 1vw + 0.3rem, 0.875rem);
  color: #f1c40f;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: 700;
  margin-bottom: 15px;
}

.hero-card h1 {
  font-size: clamp(1.75rem, 3.5vw + 0.5rem, 3rem);
  color: #f1c40f;
  margin: 0 0 25px;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.7);
  font-family: 'Roboto Slab', sans-serif;
}

.hero-card .hero-intro {
  font-size: clamp(0.95rem, 1vw + 0.5rem, 1.12rem);
  line-height: 1.8;
  color: #e8e8e8;
  max-width: 820px;
  margin: 0 auto 10px;
  font-family: 'Roboto', sans-serif;
}

.hero-section .hero-actions {
  display: flex;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
  margin: 25px 0 30px;
}

.hero-phone-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 320px;
  padding: 16px 28px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 10px;
  background: linear-gradient(135deg, #8d0808 0%, #bf1414 55%, #e04a2d 100%);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.34), 0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  color: #fff;
  font-size: 1.08rem;
  font-weight: 600;
  letter-spacing: 0.4px;
  line-height: 1.2;
  text-decoration: none;
  transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;
}

.hero-phone-link .phone-icon {
  flex-shrink: 0;
}

.hero-phone-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  filter: brightness(1.05);
}

.hero-phone-link:active {
  transform: translateY(1px) scale(0.995);
  filter: brightness(0.98);
}

.hero-phone-link:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 2px;
}

@media (min-width: 1025px) {
  .hero-phone-link {
    border-radius: 8px;
    font-size: 1.02rem;
    box-shadow: 0 7px 16px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  }
}

@media (max-width: 1024px) {
  .hero-phone-link {
    width: 100%;
    min-width: 0;
  }
}

.other-location-link {
  display: inline-block;
  margin: -12px auto 24px;
  padding: 8px 16px;
  border: 1px solid rgba(241, 196, 15, 0.6);
  border-radius: 999px;
  background: rgba(0, 20, 45, 0.45);
  color: #f5f5f5;
  font-size: 0.95rem;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

.other-location-link span {
  color: #f1c40f;
  font-weight: 700;
}

.other-location-link:hover {
  background: rgba(241, 196, 15, 0.15);
}

.other-location-link:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 3px;
}

.trust-points {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  text-align: left;
}

.trust-points li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: clamp(14px, 2.5vw, 18px) clamp(14px, 3vw, 20px);
  background: rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  border-left: 4px solid #f1c40f;
  color: #f5f5f5;
  font-size: clamp(0.95rem, 1.8vw + 0.3rem, 1.05rem);
  line-height: 1.6;
}

.trust-points li::before {
  content: "✓";
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  background: #f1c40f;
  color: #1a1a1a;
  font-size: 0.8rem;
  font-weight: 900;
  margin-top: 1px;
}

@media (max-width: 600px) {
  .trust-points {
    grid-template-columns: 1fr;
  }

  .trust-points li {
    padding: 14px 16px;
    gap: 10px;
  }
}

.hero-quote-actions {
  margin-top: 10px;
}

@media (max-width: 880px) {
  .hero-section {
    padding: 24px 20px;
  }
}

.ServicesTitle{
 color: #f1c40f;
   text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
   letter-spacing: 1px;
   font-size: 2.2em;
   position: relative;
   z-index: 2;
   padding-bottom: 10px;
   border-bottom: 3px solid #f1c40f;
   display: inline-block;
}

.Bold{
 font-weight: bold;
}

.Services{
  max-width: 1080px;
  margin: 0 auto;
  padding: 30px;
   display: flex;
   flex-direction: column;
   background: transparent;
   text-align: center;
}


.Services .Title {
 width: 100%;
 display: flex;
 justify-content: center;
 padding: 15px;
 font-size: -webkit-xxx-large;
}.services-wide {
  max-width: 1300px;
}
.serviceSelection {
 display: flex;
 justify-content: center;
 flex-direction: row;
 flex-wrap: wrap;
 gap: 20px;
 margin-top: 25px;
}

.section-intro {
    font-size: clamp(0.95rem, 1vw + 0.5rem, 1.12rem);
    line-height: 1.8;
    color: #e8e8e8;
}

.service-area-list {
    list-style: none;
    padding: 0;
    margin: 20px auto 0;
    max-width: 900px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
}

.service-area-list li {
    padding: 10px 18px;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 999px;
    border: 1px solid rgba(241, 196, 15, 0.4);
    color: #f5f5f5;
    font-size: clamp(0.85rem, 1vw + 0.3rem, 0.98rem);
}

.map-embed {
    width: 100%;
    margin: 25px auto 0;
    max-width: 900px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(241, 196, 15, 0.4);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.map-embed iframe {
    display: block;
    width: 100%;
    height: 320px;
    border: 0;
}

@media (max-width: 600px) {
    .map-embed iframe {
        height: 260px;
    }
}

.photo-card {
   display: flex;
   flex-direction: column;
  color: #f5f5f5;
   justify-content: center;
   align-items: center;
}


.HomeImage{
 height: 100%;
 width: 100%;
 border-radius: 10px;
 object-fit: cover;

 @media (max-width: 1024px) {
   margin-bottom: 20px;

 }
}
.break{
 width: 100%;
 border-bottom: #f1c40f .2em solid;
}
.show-contact-form {
 position: fixed;
 bottom: 20px;
 right: 20px;
 display: block;
}
.floatingContact {

 .contact-button {

  position: fixed;
  bottom: max(16px, env(safe-area-inset-bottom));
  right: max(16px, env(safe-area-inset-right));
  background: linear-gradient(145deg, #a10d10 0%, #d3181c 100%);
  color: white;
  border: 2px solid rgba(241, 196, 15, 0.95);
  border-radius: 999px;
  min-width: 176px;
  max-width: 220px;
  height: 56px;
  padding: 0 18px;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
  gap: 0;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4), 0 0 0 0 rgba(241, 196, 15, 0.55);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  animation: ctaAttention 5.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  z-index: 100;

   @media (max-width: 500px){
    min-width: 160px;
    height: 52px;
    font-size: 0.86rem;
    padding: 0 14px;
   }
  }

  .financing-button {
    display : none;
}
}
.subTitle {
 font-family: 'Roboto', sans-serif; /* Use Open Sans font */
 font-size: 1.5em; /* Increase font size */
 font-weight: bold; /* Make text bold */
 letter-spacing: 0.5px; /* Add some letter spacing */
 text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.55);
 color: #e8e8e8; /* White text */
}

.floatingContact .contact-button:hover {
  transform: translateY(-2px);
  background: linear-gradient(145deg, #b41013 0%, #e01f24 100%);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.45), 0 0 0 6px rgba(241, 196, 15, 0.14);
}

.floatingContact .contact-button:active {
  transform: translateY(0);
}

.floatingContact .contact-button:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .floatingContact .contact-button {
    transition: none;
    animation: none;
  }
}

@keyframes ctaAttention {
  0%, 72%, 100% {
    transform: translateY(0);
  }
  10% {
    transform: translateY(-1px) scale(1.02);
  }
  18% {
    transform: translateY(0);
  }
}

 
 </style>